import { Button, Message, Notes, Popup } from 'common/components';
import { ActionType } from '../containers/CompletionBoard';
import React from 'react';
import { Glossary, BoardGL } from 'common/utils/glossary';

interface CompletionBoardProps {
  actionType: ActionType;
  isDisplay: boolean;
  isFailed: boolean;
  glossary: Glossary;
  alertMessage: string;
  onClickClose: () => void;
}

export const CompletionBoard: React.FC<CompletionBoardProps> = ({
  actionType,
  isDisplay,
  isFailed,
  glossary,
  alertMessage,
  onClickClose
}) => {
  const completionTitle = () => {
    if (actionType == ActionType.REGISTER) {
      return glossary.glx(BoardGL.useSettingUserOther);
    } else if (actionType == ActionType.INDIVIDUAL_CANCEL) {
      return glossary.glx(BoardGL.cancelPlan);
    } else {
      return glossary.glx(BoardGL.removeOtherUser);
    }
  };
  const completionMessage = () => {
    if (actionType == ActionType.REGISTER) {
      if (alertMessage == '') {
        return glossary.glx(BoardGL.registered);
      } else {
        return alertMessage;
      }
    } else if (actionType == ActionType.INDIVIDUAL_CANCEL) {
      if (!isFailed) {
        return glossary.glx(BoardGL.cancellationComplete);
      } else {
        return glossary.glx(BoardGL.cancellationFailure);
      }
    } else {
      if (!isFailed) {
        return glossary.glx(BoardGL.deleted);
      } else {
        return glossary.glx(BoardGL.deletingFailure);
      }
    }
  };

  const _component = (
    <Popup
      className="completionBoard-popup"
      onClickBackground={onClickClose}
      data-test="completionBoard-popup"
      visible={isDisplay}
    >
      <div className="completionBoard">
        <Message type="message" data-test="completionBoard-message">
          {completionTitle()}
        </Message>
        <div className="noteArea">
          {completionMessage().includes('\n') ? (
            <Notes
              notes={[completionMessage()]}
              className="note-break"
              data-test={'completionBoard-notes'}
            />
          ) : (
            <Notes
              notes={[completionMessage()]}
              data-test={`completionBoard-notes`}
            />
          )}
        </div>
        <div className="buttonFlex">
          <Button
            className="cancelButton"
            type="toolButton"
            onClick={onClickClose}
            data-test="completionBoard-cancelButton"
          >
            {glossary.glx(BoardGL.Ok)}
          </Button>
        </div>
      </div>
    </Popup>
  );
  return isDisplay ? _component : null;
};

export default CompletionBoard;
